import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useMemo } from 'react';
import cn from 'classnames';
import { motion } from 'framer-motion';
import { getTestIds } from '../../utils/TestIds';
import { useTypewriterLoop } from '../../utils/useTypewriterLoop';
import { TextField } from '../TextField';
import styles from './AnimatedTextField.module.scss';
export const GetAnimatedTextFieldTID = (parentTestId)=>getTestIds(parentTestId);
export const AnimatedTextField = (_0)=>{
    let { suggestions, staticPrefix = '', value, onChange, onBlur, disabled = false, error, helperText, collapseHelperText, showHelperTextOnFocusOnly, inputRef, placeholder, testId, label, className, multiline, minRows, maxRows, inputRootClass, inputProps } = _0, biProps = _object_without_properties(_0, [
        "suggestions",
        "staticPrefix",
        "value",
        "onChange",
        "onBlur",
        "disabled",
        "error",
        "helperText",
        "collapseHelperText",
        "showHelperTextOnFocusOnly",
        "inputRef",
        "placeholder",
        "testId",
        "label",
        "className",
        "multiline",
        "minRows",
        "maxRows",
        "inputRootClass",
        "inputProps"
    ]);
    const { AnimatedTextFieldTID } = useMemo(()=>GetAnimatedTextFieldTID(testId), [
        testId
    ]);
    const placeholderState = useTypewriterLoop({
        disabled,
        value,
        suggestions
    });
    const showAnimatedPlaceholder = !disabled && !value && suggestions.length > 0;
    const textFieldProps = {
        value,
        onChange,
        onBlur,
        disabled,
        error,
        helperText,
        collapseHelperText,
        showHelperTextOnFocusOnly,
        inputRef,
        label,
        placeholder: showAnimatedPlaceholder ? '' : placeholder,
        testId: AnimatedTextFieldTID.TextField(),
        multiline,
        minRows,
        maxRows,
        inputRootClass,
        inputProps
    };
    return /*#__PURE__*/ _jsxs("div", {
        className: cn(styles.container, className),
        "data-testid": AnimatedTextFieldTID.Root(),
        children: [
            /*#__PURE__*/ _jsx(TextField, _object_spread({}, _object_spread({}, textFieldProps, biProps))),
            showAnimatedPlaceholder && /*#__PURE__*/ _jsxs(motion.div, {
                className: cn(styles.animatedPlaceholder, {
                    [styles.multiline]: multiline
                }),
                animate: {
                    opacity: placeholderState.opacity
                },
                transition: {
                    duration: placeholderState.duration
                },
                "data-testid": AnimatedTextFieldTID.AnimatedPlaceholder(),
                children: [
                    staticPrefix,
                    placeholderState.displayedText,
                    placeholderState.isTyping && /*#__PURE__*/ _jsx("span", {
                        className: styles.cursor,
                        children: "|"
                    })
                ]
            })
        ]
    });
};
